import _classCallCheck from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { HachureFiller } from './hachure-filler';
export var HatchFiller = /*#__PURE__*/function (_HachureFiller) {
  _inherits(HatchFiller, _HachureFiller);

  var _super = _createSuper(HatchFiller);

  function HatchFiller() {
    _classCallCheck(this, HatchFiller);

    return _super.apply(this, arguments);
  }

  _createClass(HatchFiller, [{
    key: "fillPolygon",
    value: function fillPolygon(points, o) {
      var set = this._fillPolygon(points, o);

      var o2 = Object.assign({}, o, {
        hachureAngle: o.hachureAngle + 90
      });

      var set2 = this._fillPolygon(points, o2);

      set.ops = set.ops.concat(set2.ops);
      return set;
    }
  }]);

  return HatchFiller;
}(HachureFiller);